import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { MonoTypeOperatorFunction, Observable, combineLatest, concatMap, defer, map, of } from 'rxjs';

import { ApiService, AvailableOptions } from 'ish-core/services/api/api.service';
import { whenTruthy } from 'ish-core/utils/operators';

import {
  getDotCmsApiEndpoint,
  getDotCmsApitoken,
} from '../../store/dotcms-configuration/dotcms-configuration.selectors';

@Injectable({ providedIn: 'root' })
export class DotCmsApiService {
  constructor(private apiService: ApiService, private store: Store) {}

  private appendAuthenticationToken(): MonoTypeOperatorFunction<HttpHeaders> {
    return headers$ =>
      combineLatest([headers$, this.store.pipe(select(getDotCmsApitoken), whenTruthy())]).pipe(
        map(([headers, token]) => headers.set(ApiService.AUTHORIZATION_HEADER_KEY, `Bearer ${token}`))
      );
  }

  //Todo: need to check the reduce function
  private constructHeaders(options?: AvailableOptions): Observable<HttpHeaders> {
    const defaultHeaders = new HttpHeaders().set('content-type', 'application/json').set('Accept', 'application/json');
    return of(
      options?.headers
        ? // append incoming headers to default ones
          options.headers.keys().reduce((acc, key) => acc.set(key, options.headers.get(key)), defaultHeaders)
        : // just use default headers
          defaultHeaders
    ).pipe(this.appendAuthenticationToken());
  }

  private constructUrlForPath(path: string): Observable<string> {
    return this.store.pipe(
      select(getDotCmsApiEndpoint),
      whenTruthy(),
      map(url => url.concat(path))
    );
  }

  private constructHttpClientParams(
    path: string,
    options?: AvailableOptions
  ): Observable<[string, { headers: HttpHeaders; params: HttpParams }]> {
    return combineLatest([
      this.constructUrlForPath(path),
      defer(() =>
        this.constructHeaders(options).pipe(
          map(headers => ({
            headers,
            params: options?.params,
            responseType: options?.responseType,
          }))
        )
      ),
    ]);
  }
  get<T>(path: string, options?: AvailableOptions): Observable<T> {
    return this.constructHttpClientParams(path, options).pipe(
      concatMap(([url, httpOptions]) => this.apiService.get<T>(url, httpOptions))
    );
  }
}
